import { StatusCodes } from 'http-status-codes';
import { axiosInstance } from './axiosInstance';

export const getBusinessList = async () => {

  let response;

  try {

    response = await axiosInstance.get('/businesses');

    if (response.status !== StatusCodes.OK || !response.data) {

      throw new Error('GetbusinessListError');
    }

  } catch (error) {

    const errorResponse = error.response || {};

    if (errorResponse.status === StatusCodes.NOT_FOUND) {
      response = { data: null };
    } else {
      throw error;
    }
  }

  return response.data;
};
